import { render, staticRenderFns } from "./Ticketltem.vue?vue&type=template&id=391c43b2&scoped=true&"
import script from "./Ticketltem.vue?vue&type=script&lang=ts&"
export * from "./Ticketltem.vue?vue&type=script&lang=ts&"
import style0 from "./Ticketltem.vue?vue&type=style&index=0&id=391c43b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c43b2",
  null
  
)

export default component.exports